(function () {
    "use strict";
    const Papa = require('papaparse');

    /**
     * @module dataTable
     * 
     */

    const dataTable = {
        init: function () {           
            const wrapperElements = document.querySelectorAll('.qld__data-table');
            
            wrapperElements.forEach(function (element) {
                const options = {
                    assetId:element.dataset.assetId,
                    filterColumns: parseMultiToArray(element.dataset.filterColumns).map(function (s) { return s - 1 }),
                    rightColumns: parseMultiToArray(element.dataset.rightColumns).map(function (s) { return s - 1 }),
                    centerColumns: parseMultiToArray(element.dataset.centerColumns).map(function (s) { return s - 1 }),
                    csvFileURL: element.dataset.csvSource,
                    filterAsTags: parseYesNoToBoolean(element.dataset.filterAsTags)
                };
                const dataTableManager = new DataTableManager(element, options);

            });

            
            // modify to handle tag filters toggles
            document.addEventListener("click", function (event) {
                const clearButton = event.target.closest('[data-role="dt-clear-filters"]');
                if (clearButton) {
                    event.preventDefault();
                    const filterWrapper = clearButton.closest(".qld__data_table__filter_wrapper");
                    if (filterWrapper) {
                        resetFilters(filterWrapper);
                    }
                    return;
                }

                const closeButton = event.target.closest('[data-role="dt-filter-close"]');
                if (closeButton) {
                    event.preventDefault();
                    const filterWrapper = closeButton.closest(".qld__data_table__filter_wrapper");
                    const filterTag = closeButton.closest(".qld__tag--filter");
                    if (filterTag && filterWrapper) {
                        const dataSelect = filterTag.dataset.select;
                        if (dataSelect) {
                            const selectElement = filterWrapper.querySelector(`.qld__select--filter[data-name="${dataSelect}"]`);
                            if (selectElement) {
                                selectElement.value = '';
                                const changeEvent = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(changeEvent);
                            }
                        }
                    }
                    return;
                }
            });

            function resetFilters(filterWrapper) {
                // Reset select values to nothing
                filterWrapper.classList.remove('filters-active');
                const selectElements = filterWrapper.querySelectorAll(".qld__select--filter");
                selectElements.forEach(function(selectElement) {
                    selectElement.value = "";
                    const changeEvent = new Event('change');
                    selectElement.dispatchEvent(changeEvent);
                });
            
                // Remove all .qld__tag--filter elements
                const tagFilterElements = filterWrapper.querySelectorAll(".qld__tag--filter");
                tagFilterElements.forEach(function(tag) {
                    tag.parentElement.remove();
                });

            }
            
        }
    };

    class DataTableManager {
        constructor(wrapperElement, options) {
            this.wrapperElement = wrapperElement;
            this.options = options;
            this.dataTableInstance = null; 
            this.init();
        }

        init() {
            if (this.wrapperElement.hasAttribute('data-csv-source')) {
                this.dataTableCsv();
            } else {
                this.dataTableHtml();
            }
        }

        initColumnSearch() {
            const self = this;
            const filterColumns = this.options.filterColumns;
            const wrapperElement = this.wrapperElement;
            const useTagList = !!this.options.filterAsTags;

            if (filterColumns.length == 0) return;
            const search = $("<tr class='dt-search'></tr>");
            const filterElement = $(wrapperElement).find('.qld__data_table__filter');
            this.dataTableInstance.columns().every(function () {
                const column = this;
                if (this.visible()) {
                    const index = this.index();
                    const title = $(column.header()).text();
                    const filterItem = $(`<div class="filter_item"></div>`);
                    if (filterColumns.indexOf(index) >= 0) {
                        // Build unique, cleaned values for the column
                        const uniqueValues = [];
                        column.data().unique().sort().each(function (d) {
                            const dom = $.parseHTML(d) || [];
                            const clean = dom.map(function (e) { return e.textContent }).join('');
                            if (uniqueValues.indexOf(clean) === -1) uniqueValues.push(clean);
                        });

                        if (useTagList) {
                            // Tag list UI
                            const fieldset = $(`<fieldset class="qld__fieldset"></fieldset>`);
                            const legend = $(`<legend class="qld__label">Filter by ${title.toLowerCase()}:</legend>`);
                            const list = $(`<ul class="qld__search__filters-list qld__tag-list" data-name="col${index}"></ul>`);

                            uniqueValues.forEach(function (val) {
                                const li = $('<li></li>');
                                const a = $(`<a href="#" role="button" aria-pressed="false" class="qld__tag qld__tag--link qld__tag--large" data-value="${val}">${val}<i class="fa-light fa-circle-xmark qld__icon--trail qld__icon--sm" aria-hidden="true"></i></a>`);
                                a.on('click', function (event) {
                                    event.preventDefault();
                                    const $link = $(this);
                                    const wasActive = $link.hasClass('qld__tag--active');

                                    // Ensure only one active per column
                                    $link.closest('ul').find('.qld__tag--active').removeClass('qld__tag--active').attr('aria-pressed', 'false');

                                    if (wasActive) {
                                        // Toggle off: clear the filter
                                        $link.attr('aria-pressed', 'false');
                                        column.search('', true, false).draw();
                                    } else {
                                        // Activate and apply filter
                                        $link.addClass('qld__tag--active').attr('aria-pressed', 'true');
                                        const val = $.fn.dataTable.util.escapeRegex($link.data('value'));
                                        column.search(val ? '^' + val + '$' : '', true, false).draw();
                                    }

                                    self.updateFilteredBy();
                                });

                                li.append(a);
                                list.append(li);
                            });

                            fieldset.append(legend);
                            fieldset.append(list);
                            filterItem.append(fieldset);
                            filterElement.append(filterItem);
                        } else {
                            // Select UI (existing behaviour)
                            const label = $(`<label for="filter_${self.options.assetId}_col${index}" class="qld__label">${title}</label>`);
                            const wrapper = $(`<div class="qld__select"></div>`);
                            const field = $(`<select id="filter_${self.options.assetId}_col${index}" class="qld__select-control qld__select--filter qld__text-input--block" data-name="col${index}"><option value="">Select ${title}</option></select>`);
                            field.on('change', function (event) {
                                var val = $.fn.dataTable.util.escapeRegex($(this).val());
                                column.search(val ? '^' + val + '$' : '', true, false).draw();
                                field.toggleClass('filtered', val != "");
                                self.updateFilteredBy();
                            });
                            // Populate options using the prepared unique values
                            uniqueValues.forEach(function (clean) {
                                if ($('option[value=' + JSON.stringify(clean) + ']', field).length == 0) {
                                    field.append('<option value="' + clean + '">' + clean + '</option>');
                                }
                            });
                            filterItem.append(label);
                            wrapper.append(field);
                            filterItem.append(wrapper);
                            filterElement.append(filterItem);
                        }
                    } 
                }
            });

            $(this.dataTableInstance.table().header()).append(search);
            this.updateFilteredBy();
            window.dispatchEvent(new Event('resize'));
        }

        updateFilteredBy() {
            const wrapperElement = this.wrapperElement;

            const filterContainer = wrapperElement.querySelector('.qld__data_table__filter_wrapper');
            if (!filterContainer) {
                return;
            }

            // Collect selected filters from selects
            const selections = [];
            const selectElements = wrapperElement.querySelectorAll(".qld__select--filter");
            selectElements.forEach(function (select) {
                if (select.value) {
                    selections.push({ name: select.dataset.name, value: select.value });
                }
            });

            // Collect selected filters from tag lists (only one active per column by design)
            const tagLists = wrapperElement.querySelectorAll(".qld__tag-list[data-name]");
            tagLists.forEach(function (ul) {
                const active = ul.querySelector(".qld__tag--active");
                if (active && active.dataset.value) {
                    selections.push({ name: ul.dataset.name, value: active.dataset.value });
                }
            });

            // Determine the aggregate filters list (the one that contains the clear button)
            const lists = wrapperElement.querySelectorAll("[data-active-filters]");
            let filtersList = null;
            lists.forEach(function (list) {
                if (!filtersList && list.querySelector('[data-role="dt-clear-filters"]')) {
                    filtersList = list;
                }
            });

            // Toggle container state
            if (selections.length > 0) {
                filterContainer.classList.add('filters-active');
            } else {
                filterContainer.classList.remove('filters-active');
            }

            // If no aggregate list exists, nothing else to render
            if (!filtersList) return;

            const clearFiltersButton = filtersList.querySelector('[data-role="dt-clear-filters"]');
            const lastLiElement = clearFiltersButton ? clearFiltersButton.parentElement : null;

            // Remove aggregate tags that are no longer selected
            filtersList.querySelectorAll('.qld__tag--filter[data-select]').forEach(function (tag) {
                const name = tag.getAttribute('data-select');
                if (!selections.find(function (s) { return s.name === name; })) {
                    tag.parentElement.remove();
                }
            });

            // Add/update aggregate tags for current selections
            selections.forEach(function (sel) {
                const existingTag = filtersList.querySelector(`.qld__tag--filter[data-select="${sel.name}"]`);
                if (existingTag) {
                    existingTag.parentElement.remove();
                }
                const liItem = `<li>
                        <div class="qld__tag qld__tag--large qld__tag--filter" data-select="${sel.name}">
                            ${sel.value}<button class="qld__tag--filter-close" data-role="dt-filter-close"><span class="sr-only">Remove ${sel.value} filter</span></button>
                        </div>
                    </li>`;
                if (lastLiElement) {
                    lastLiElement.insertAdjacentHTML('beforebegin', liItem);
                }
            });
        }

        /**
         * Draws a DataTable within the specified table element using the provided configuration.
         *
         * @param {jQuery|HTMLElement} tableElement - The jQuery object or DOM element of the HTML table in which the DataTable will be drawn.
         * @param {Object} [dataTableOptions={}] - The configuration options for override default ones for the DataTable.
         */
        drawTable(tableElement, dataTableOptions = {}) {

            const self = this;
            const wrapperElement = this.wrapperElement;
            const numColumns = $(tableElement).find('thead th').length || (dataTableOptions.hasOwnProperty('columns') ? dataTableOptions.columns.length : 0);

            const filteredRightColumns = (this.options.rightColumns || []).filter(idx => idx >= 0 && idx < numColumns);
            const filteredCenterColumns = (this.options.centerColumns || []).filter(idx => idx >= 0 && idx < numColumns);

            const rightColumnsConfig = { targets: filteredRightColumns, className: 'dt-right' };
            const centerColumnsConfig = { targets: filteredCenterColumns, className: 'dt-center' };

            const searchInputId = `qld__data-table__search-field_${self.options.assetId || Math.random().toString(36).slice(2)}`;

            const defaultOptions = {
                "sScrollX": "100%",
                "sScrollXInner": "100%",
                "bScrollCollapse": true,
                "dom": '<"top"if>rt<"bottom"lp><"clear">',
                "pagingType": "simple_numbers",
                "pagingTag": "li",
                "order": [],
                "pageLength": parseInt(self.options.pageSize, 10) || 10,
                "lengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                "language": {
                    "paginate": {
                        "previous": `<a rel="prev"
                                aria-label="Previous page of results" class="qld__search-pagination_link">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false"
                                    width="16" height="16" role="img">
                                    <path fill="currentColor"
                                        d="M448 256C448 264.8 440.6 272 431.4 272H54.11l140.7 149.3c6.157 6.531 5.655 16.66-1.118 22.59C190.5 446.6 186.5 448 182.5 448c-4.505 0-9.009-1.75-12.28-5.25l-165.9-176c-5.752-6.094-5.752-15.41 0-21.5l165.9-176c6.19-6.562 16.69-7 23.45-1.094c6.773 5.938 7.275 16.06 1.118 22.59L54.11 240h377.3C440.6 240 448 247.2 448 256z">
                                    </path>
                                </svg><span>Back</span>
                            </a>`,
                        "next": `<a rel="next" aria-label="Next page of results" class="qld__search-pagination_link">
                                    <span>Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M443.7 266.8l-165.9 176C274.5 446.3 269.1 448 265.5 448c-3.986 0-7.988-1.375-11.16-4.156c-6.773-5.938-7.275-16.06-1.118-22.59L393.9 272H16.59c-9.171 0-16.59-7.155-16.59-15.1S7.421 240 16.59 240h377.3l-140.7-149.3c-6.157-6.531-5.655-16.66 1.118-22.59c6.789-5.906 17.27-5.469 23.45 1.094l165.9 176C449.4 251.3 449.4 260.7 443.7 266.8z"></path></svg>
                                    </a>`,
                    },
                    "sEmptyTable": "No data available in table",
                    "sInfo": "<span class='qld__data-table-item-numbers'><span class='qld__data-table-item-numbers-heading'>Showing:</span> _START_&ndash;_END_ of <span class='qld__data-table-item-numbers-total'>_TOTAL_ entries</span></span>",
                    "sInfoEmpty":
                        "<span class='qld__data-table-item-numbers'><span class='qld__data-table-item-numbers-heading'>Showing:</span> 0&ndash;0 of <span class='qld__data-table-item-numbers-total'>0 entries</span></span>",
                    "sInfoFiltered": "(filtered from _MAX_ total entries)",
                    "sInfoPostFix": "",
                    "sDecimal": "",
                    "sThousands": ",",
                    "sLengthMenu": "<span>Items per page</span> _MENU_",
                    "sLoadingRecords": "Loading...",
                    "sProcessing": "",
                    "sSearch": `Search:<input type="search" id="${searchInputId}" name="query" class="qld__data-table__search-field qld__text-input" autocomplete="off" value=""></input>`,
                    "sSearchPlaceholder": "",
                    "sUrl": "",
                    "sZeroRecords": "No matching records found",
                },
                "columnDefs": [
                    rightColumnsConfig,
                    centerColumnsConfig
                ],
                "oClasses": {
                    "sFilterInput": "qld__text-input",
                    "sPageButton": "qld__search-pagination_link ",
                    "sPageButtonActive": "active",
                    "sPageButtonDisabled": "disabled",
                    "sPaging": "dataTables_paginate paging_ qld__search-pagination ",

                },
                "drawCallback": function (settings) {
                    var parentDiv = $(wrapperElement).find("div.qld__search-pagination");
                    var ulElement = $(
                        '<ul class="qld__search-pagination__list"></ul>'
                    );
                    parentDiv.children().appendTo(ulElement);
                    ulElement.appendTo(parentDiv);

                    $(wrapperElement).find(".qld__search-pagination_link").each(function () {
                        var $this = $(this);
                        if (
                            $this.children("a").length === 0 &&
                            $this.children("span").length === 0 &&
                            $this.children("svg").length === 0
                        ) {
                            var textContent = $this.text();
                            $this.html('<a class="num">' + textContent + "</a>");
                        }
                    });

                    $(wrapperElement).find(".qld__search-pagination__list > span:not([class])").each(
                        function () {
                            var $span = $(this);

                            // Move the nested <li> elements outside of the <span>
                            $span.before($span.contents());

                            // Remove the empty <span>
                            $span.remove();
                        }
                    );
                    $(wrapperElement).find(".qld__search-pagination__list > span.ellipsis").replaceWith(`
                        <li class="ellipsis" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="24" height="32" role="img">
                                <path fill="currentColor" d="M352 256C352 238.3 366.3 224 384 224C401.7 224 416 238.3 416 256C416 273.7 401.7 288 384 288C366.3 288 352 273.7 352 256zM192 256C192 238.3 206.3 224 224 224C241.7 224 256 238.3 256 256C256 273.7 241.7 288 224 288C206.3 288 192 273.7 192 256zM96 256C96 273.7 81.67 288 64 288C46.33 288 32 273.7 32 256C32 238.3 46.33 224 64 224C81.67 224 96 238.3 96 256z"></path>
                            </svg>
                        </li>
                    `);
                    $(wrapperElement).find("li.previous").addClass("prev"); //adding the appropriate class



                },
                "initComplete": function(settings, json) {
                }
            };

            const mergedOptions = { ...defaultOptions, ...dataTableOptions };
            this.dataTableInstance = $(tableElement).DataTable(mergedOptions);
            const QLD_DataTable = this.dataTableInstance;

            this.initColumnSearch();

            this.updateFooterClasses();

            QLD_DataTable.on("order.dt", function () {
                let order = QLD_DataTable.order()[0]; // Get the column index being sorted
                $(wrapperElement).find("tfoot tr th").removeClass("sorting_asc sorting_desc sorting sorting_1 sorting_2 sorting_3");
                if(order){
                    $(wrapperElement).find("tfoot tr th:nth-child(" + (order[0] + 1) + ")").addClass("sorting_1");
                }
            });

        }

        updateFooterClasses() {
            const QLD_DataTable = this.dataTableInstance;
            const orderColumns = QLD_DataTable.order();
            orderColumns.forEach(([columnIndex, order], iteratorIndex) => {
                const column = QLD_DataTable.column(columnIndex);
                const headerCell = $(column.header());
                const footerCell = $(column.footer());

                const sortingClass = `sorting_${iteratorIndex + 1}`;
                footerCell.addClass(sortingClass);
            });

        }

        dataTableCsv() {
            const tableWrapper = this.wrapperElement.querySelector('.qld__data-table-content');
            const self = this;
            if (tableWrapper) {
                tableWrapper.style.display = "block";
                const csvTable = $('<table></table>').appendTo(tableWrapper);
                const csvFileURL = this.options.csvFileURL;
                var processCSV = function (results, file) {
                    const tableColumnHeads = results.meta.fields.map(function(c, i){return c});
                    const tableData = results.data; 

                    // Defining variables that are included in the table using the processed data from the functions.
                    let tableColumns = tableColumnHeads.map((column) => {
                        return { data: column, title: column };
                    });

                    self.drawTable(csvTable, {
                        data: tableData ? tableData : [],
                        columns: tableColumns ? tableColumns : [],
                    });
                }

                const papaConfig = {
                    delimiter: ",",
                    quoteChar: '"',
                    skipEmptyLines: true,
                    header: true,
                    download: true,
                    transform:  function(val) {return val.replace(/\n/g,'<br>')},
                    complete: processCSV
                };
                Papa.parse(csvFileURL, papaConfig);

            }

        }

        dataTableHtml() {
            const tableWrapper = this.wrapperElement.querySelector('.qld__data-table-content');

            if (tableWrapper) {
                tableWrapper.style.display = "block";

                const tableElement = $(tableWrapper).find("table");
                this.drawTable(tableElement);

            }

        }
    }

    /**
     * Parses a string input and returns a boolean value. Useful for Metadata fields that use Yes,No as their values.
     * @param {string} input - The input string to be parsed.
     * @returns {boolean} - Returns true if input is "yes" (case-insensitive), false otherwise.
     */
    const parseYesNoToBoolean = (input) => /^yes$/i.test(input);

    /**
     * Converts a semicolon-separated metadata string into an array of trimmed substrings.
     *
     * @param {string} metadataString - The semicolon-separated metadata string.
     * @returns {string[]} An array of trimmed substrings from the metadata string.
     */
    const parseMultiToArray = (metadataString) => {
        if (typeof metadataString !== 'string') {
            metadataString = '';
        }
        return metadataString.split(';').map(s => s.trim()).filter(s => s !== "");
    };

    /**
     * Retrieves the value of a query parameter from the current URL.
     *
     * @param {string} sParam - The name of the query parameter to retrieve.
     * @returns {string|boolean|null} The value of the query parameter if found, `true` if the parameter is present without a value, or null if the parameter is not found.
     */
    const getUrlParam = (sParam) => {
        var sURLVariables = window.location.search.substring(1).split('&')
        for (let i = 0; i < sURLVariables.length; i++) {
            var parts = sURLVariables[i].split('=').map(function (s) { return decodeURIComponent(s); });
            if (parts[0].toLowerCase() === sParam.toLowerCase()) {
                return parts[1] === undefined ? true : parts[1];
            }
        }
        return null;
    }


    // Ensure QLD namespace exists
    window.QLD = window.QLD || {};
    QLD.dataTable = dataTable;
    document.addEventListener("DOMContentLoaded", QLD.dataTable.init);

})();